import React, { useState, useEffect, useRef, useCallback, forwardRef } from 'react'
// import { createPortal } from 'react-dom'
import { DefaultRecordType } from './interface';


interface HoverContentProps {
    // hoverContentClass?: string,
    children?: React.ReactNode,
    store: { setState: (partial: any) => void; getState: () => any; subscribe: (listener: any) => void;};
    // hoverContentStyle?: React.CSSProperties;
    hoverContent?: (data?: DefaultRecordType | null, index?: number | null) => JSX.Element | null;
}

interface HoverContentState {
    currentHoverKey?: string | number | null,
    currentRecord?: DefaultRecordType | null,
    currentIndex?: number | null,
    hoverContentClass?: any,
    hoverContentStyle?: React.CSSProperties;
}

const HoverContent = forwardRef<any, HoverContentProps>(({ store, hoverContent }, ref) => {
    const [state, setState] = useState<HoverContentState>({
        currentHoverKey: null,
        currentRecord: null,
        currentIndex: null,
        hoverContentClass: undefined,
        hoverContentStyle: undefined
    });

    const unsubscribeRef = useRef<any>(null);
    const originStyleRef = useRef<React.CSSProperties>({});

    useEffect(() => {
        if (!unsubscribeRef.current) {
            const listener = () => {
                const storeState = store.getState();
                console.log(storeState)
                const storeHeight = storeState.hoverContentStyle?.height;
                const stateHeight = state.hoverContentStyle?.height;

                if (storeState.currentHoverKey !== state.currentHoverKey ||
                    storeState.currentHoverKey == null ||
                    storeHeight !== stateHeight) {
                    setState({
                        currentHoverKey: storeState.currentHoverKey,
                        currentRecord: storeState.currentRecord,
                        currentIndex: storeState.currentIndex,
                        hoverContentClass: storeState.hoverContentClass,
                        hoverContentStyle: storeState.hoverContentStyle
                    });
                }
                originStyleRef.current = {};
            };

            unsubscribeRef.current = store.subscribe(listener);
        }

        return () => {
            // const { store } = this.props
            // if (this.unsubscribe && this.listener) {
            //     store.unsubscribe(this.listener)
            //     this.listener = null
            // }
            if (unsubscribeRef.current) {
                unsubscribeRef.current();
                unsubscribeRef.current = null;
            }
            setState(prev => ({
                ...prev,
                currentHoverKey: null,
                currentRecord: null,
                currentIndex: null,
                hoverContentClass: null,
                hoverContentStyle: undefined
            }))
        };
    }, [store]);

    const onRowHoverMouseEnter = useCallback(() => {
        const storeState = store.getState();

        if (storeState.currentHoverKey || storeState.currentRecord) {
            // 保持当前store中的状态，避免组件自身的state覆盖
            originStyleRef.current.display = 'block';
        }
    }, [store, state.currentRecord, state.currentHoverKey, state.currentIndex]);

    const onRowHoverMouseLeave = useCallback(() => {
        store.setState({
            currentRecord: null,
            currentHoverKey: null,
            currentIndex: null
        });
        originStyleRef.current.display = 'none';
    }, [store]);

    const { currentRecord, currentIndex, hoverContentClass, hoverContentStyle } = state;
    const style = { ...hoverContentStyle, ...originStyleRef.current };

    return (
        <div
            ref={ref}
            style={style}
            className={hoverContentClass}
            onMouseEnter={onRowHoverMouseEnter}
            onMouseLeave={onRowHoverMouseLeave}
        >
            {currentRecord && hoverContent ? hoverContent(currentRecord, currentIndex as number) : null}
        </div>
    );
});

export default HoverContent